import { render, staticRenderFns } from "./transactions-page.vue?vue&type=template&id=73bef201&scoped=true&"
import script from "./transactions-page.vue?vue&type=script&lang=js&"
export * from "./transactions-page.vue?vue&type=script&lang=js&"
import style0 from "./transactions-page.vue?vue&type=style&index=0&id=73bef201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bef201",
  null
  
)

export default component.exports